import { h, Fragment } from 'preact'
import { useRef, useState } from 'preact/compat'
import { useTranslations } from '../../../hooks/useTranslations'
import CopyIcon from '../../../assets/icons/copy-icon.svg'
import './styles.scss'
import { getPaymentLink } from '../../../api/payLink'

export default function PaymentPayLink() {
  const l10n = useTranslations()
  const link = useRef('')
  const [showLink, setShowLink] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [showCopied, setShowCopied] = useState(false)
  const [href, setHref] = useState('')
  const urlParams = new URLSearchParams(window.location.search)
  const isGenerated = !!urlParams.get('isGeneratedByLink')
  const copyLink = () => {
    navigator.clipboard.writeText(link.current.href)
    setShowCopied(true)
    setTimeout(() => setShowCopied(false), 2000)
  }
  const getLink = async () => {
    setIsLoading(true)
    await getPaymentLink().then(res => setHref(res.responseData.paymentLink))
    setIsLoading(false)
    setShowLink(true)
  }
  return (
    <>
      {!isGenerated && (
        <tui-payments-payment-link className="payment-link mfe-component">
          {showLink ? (
            <div className="payment-link__link">
              <a
                ref={link}
                href={`${href}&isGeneratedByLink=true`}
                data-testid="payment-link"
                className="lead text payment-link__title"
              >
                {l10n.t('Payment Link')}
              </a>
              <img
                className="payment-link__icon"
                onClick={copyLink}
                src={CopyIcon}
                data-testid="copy-link"
              />
              {showCopied && (
                <span
                  data-testid="copied"
                  className="payment-link__copy-area text lead"
                >
                  {l10n.t('Copied')}
                </span>
              )}
            </div>
          ) : (
            <div>
              <button
                type="button"
                className="button primary medium action-button"
                data-testid="create-link"
                disabled={isLoading}
                onClick={getLink}
              >
                {l10n.t('Create payment link')}
              </button>
            </div>
          )}
        </tui-payments-payment-link>
      )}
    </>
  )
}
